import React, { useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';

interface LayoutProps {
  children: React.ReactNode;
  location?: { pathname?: string };
}

const Layout: React.FC<LayoutProps> = ({ children, location }) => {
  const isAdmin = (location?.pathname ?? '').includes('/admin');
  useEffect(() => {
    const pauseOthers = (event: Event) => {
      const current = event.target;
      if (!(current instanceof HTMLVideoElement)) {
        return;
      }
      document.querySelectorAll('video').forEach((video) => {
        if (video !== current && !video.paused) {
          video.pause();
        }
      });
    };

    document.addEventListener('play', pauseOthers, true);
    return () => document.removeEventListener('play', pauseOthers, true);
  }, []);

  if (isAdmin) {
    return <>{children}</>;
  }

  return (
    <>
        <Header />
        <div>
            {children}
        </div>
        <Footer />
    </>
  );
};

export default Layout;
